export default "__VITE_ASSET__BheMcJtw__"